import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import { Link } from 'react-router-dom';

const ViewPocs = ({
  match,
  getPocListing = null,
  pocList = null,
  updatePocStatus = null,
}) => {
  const headers = [
    'POC Name',
    'POC Designation',
    'Mobile Number',
    'Email Address',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [reqData, setReqData] = useState();
  const [siteId, setSiteId] = useState();
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [isMaxPocExceed, setIsMaxPocExceed] = useState(false)

  const headerBtns = () => {
    return (
      <Fragment>
        <Link
          to={`${baseUrl}/brand-activation/add-poc/${siteId}`}
          className="btn btn-primary d-md-inline-block"
        >
          Add POC
        </Link>
      </Fragment>
    );
  };
  useEffect(() => {
    setSiteId(match.params.id);
  }, []);

  useEffect(() => {
    if (getPocListing !== null && siteId)
      (async () => {
        setIsLoading(true);
        await getPocListing(siteId);
        setIsLoading(false);
      })();
  }, [getPocListing, siteId]);

  useEffect(() => {
    const tableData = ['id', 'name', 'designation', 'contact_no', 'email'];
    if (pocList && pocList !== null && pocList?.resultSets) {
      const activePocCount = pocList.resultSets.filter(
        (poc) => poc.status_num === 1
      ).length;
      setIsMaxPocExceed(activePocCount >= 10);
      const data = pocList?.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Status: element.status,
            Actions:{
              name: 'Edit Details',
              link: `${baseUrl}/brand-activation/edit-poc/${siteId}/${element.id}/${element.status_num}` ,
              from: 'pocList',
            },
          }
        )
      );
      data && setListData(data);
      setPageCount(Math.ceil(pocList.total / pocList.per_page));
    }
  }, [pocList]);

  const updateStatusPoc = async (val) => {
    let requestData = {};
    if (!val.check) {
      requestData = {
        poc_id: val.id,
        status: 2,
      };
    } else {
      requestData = {
        poc_id: val.id,
        status: 1,
      };
    }
    setReqData(requestData);
    await updatePocStatus(requestData).then(async (response) => {
      if (response) {
        await getPocListing(siteId);
      }
    });
  };

  const onPageChange = async (val) => {
    setIsLoading(true);
    await getPocListing(siteId, val.selected + 1);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.viewPOCs}
      Buttons={!isMaxPocExceed ? headerBtns : ''}
      isGoback
      isLoading={isLoading}
      linkUrl={`${baseUrl}/brand-activation/sites-listing`}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        pageCount={pageCount}
        onPageChange={onPageChange}
        srNo={pocList?.from}
      />
    </Layout>
  );
};

export default ViewPocs;
